import { IconProps } from "./types";

export const IconlyTwoUsers = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.51522 20.0955C4.10789 20.0955 3.25747 19.1824 3.19727 17.9105C3.19727 15.3216 5.99939 14.4285 10.2214 14.3984C14.4509 14.4386 17.2606 15.3316 17.2455 17.9105C17.1778 19.1824 16.3324 20.0955 14.9276 20.0955H5.51522Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.2274 11.4431C12.1879 11.4431 13.7771 9.85388 13.7771 7.89344C13.7771 5.933 12.1879 4.34375 10.2274 4.34375C8.26698 4.34375 6.67773 5.933 6.67773 7.89344C6.67773 9.85388 8.26698 11.4431 10.2274 11.4431Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9976 13.2734C19.8793 13.6672 21.0089 14.5115 21 16.0352C20.9549 16.8817 20.512 17.5448 19.7572 17.8065"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9141 5.73828C17.0676 6.0265 17.9221 7.06976 17.9221 8.31259C17.9221 9.47958 17.1687 10.4706 16.1218 10.8258"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};
